import LogoCannapp from '@assets/images/logo_cannapp.svg';
import { styled } from '@mui/joy/styles';
import { useViewport } from '@root/src/utils/hooks/useViewportSize';
import { ReactNode, useEffect, useState } from 'react';

export interface ContainerPageProps {
  size: number;
  withLogo?: boolean;
  noWrapBgColor?: boolean;
}

export interface LayoutPageProps {
  children: ReactNode;
  withCard?: boolean;
  withLogo?: boolean;
  noWrapBgColor?: boolean;
}

export interface ContentCardProps {
  size: number;
}

const ContainerPage = styled('div', {
  shouldForwardProp: prop => prop !== 'size' && prop !== 'withLogo' && prop !== 'noWrapBgColor',
})<ContainerPageProps>(({ theme, size, withLogo, noWrapBgColor }) => ({
  width: '100%',
  height: '100%',
  padding: '40px 0px 0',
  minHeight: '100vh',
  backgroundColor:
    noWrapBgColor || size >= theme.breakpoints.values.tablet ? theme.vars.palette.beige : theme.vars.palette.white,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: withLogo ? '40px' : 'unset',
}));

const ContentCard = styled('div', {
  shouldForwardProp: prop => prop !== 'size',
})<ContentCardProps>(({ theme, size }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: size < theme.breakpoints.values.tablet ? '100%' : '470px',
  padding: size < theme.breakpoints.values.tablet ? 0 : '24px',
  backgroundColor: theme.vars.palette.white,
  borderRadius: '2px',
}));

const LayoutPage = ({ children, withCard, withLogo, noWrapBgColor }: LayoutPageProps): ReactNode => {
  const width = useViewport();
  const [initWindow, setInitWindow] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setInitWindow(true);
    }
  }, []);

  return initWindow && !withCard ? (
    <ContainerPage size={width} withLogo={withLogo} noWrapBgColor={noWrapBgColor}>
      {withLogo && <LogoCannapp alt="logo_cannapp" />}
      {children}
    </ContainerPage>
  ) : (
    initWindow && (
      <ContainerPage size={width} withLogo={withLogo} noWrapBgColor={noWrapBgColor}>
        {withLogo && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
            <LogoCannapp alt="logo_cannapp" />
          </div>
        )}
        <ContentCard size={width}>{children}</ContentCard>
      </ContainerPage>
    )
  );
};

export default LayoutPage;
